import { useEffect, useState } from "react";
import SimpleCombobox from "../../components/SimpleCombobox";
import api from "../../api";

export const DatosGenerales = ({
    surgeryData,
    handleChange,
    setSurgeryData,
    surgerySchedules,
    formErrors,
}) => {
    return (
        <div className="bg-white dark:bg-gray-900 text-black dark:text-white min-h-[570px] py-8 px-6 lg:px-8 rounded-md shadow-md ">
            <div className="lg:w-9/12 flex-col space-y-6">
                <div className="flex flex-col lg:flex-row gap-6">
                    <div className="flex flex-col w-7/12">
                        <label
                            htmlFor="patient"
                            className="block font-semibold leading-6 text-gray-900 dark:text-gray-200"
                        >
                            Nombre y apellido
                        </label>
                        <input
                            type="text"
                            name="patient"
                            id="patient"
                            className="input-base disabled:bg-gray-100 dark:disabled:bg-gray-800 dark:disabled:text-gray-600 cursor-not-allowed"
                            value={surgerySchedules.patient?.fullName}
                            disabled
                        />
                    </div>
                    <div className="flex flex-col gap-3">
                        <label className="block font-semibold leading-6 text-gray-900 dark:text-gray-200">
                            ¿La ciruía fue suspendida?
                        </label>
                        <div className="flex flex-row gap-10">
                            <div className="flex flex-row gap-3 items-center">
                                <input
                                    type="radio"
                                    id="si"
                                    name="wasCanceled"
                                    value="si"
                                    checked={surgeryData.wasCanceled === true}
                                    onChange={() =>
                                        setSurgeryData((prev) => ({
                                            ...prev,
                                            wasCanceled: true,
                                        }))
                                    }
                                />
                                <label htmlFor="si">Si</label>
                            </div>
                            <div className="flex flex-row gap-3 items-center">
                                <input
                                    type="radio"
                                    id="no"
                                    name="wasCanceled"
                                    value="no"
                                    checked={surgeryData.wasCanceled === false}
                                    onChange={() =>
                                        setSurgeryData((prev) => ({
                                            ...prev,
                                            wasCanceled: false,
                                        }))
                                    }
                                />
                                <label htmlFor="no">No</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col">
                    <label
                        htmlFor="cancellationReason"
                        className="block font-semibold leading-6 text-gray-900 dark:text-gray-200"
                    >
                        Motivo de suspensión
                    </label>
                    <input
                        type="text"
                        name="cancellationReason"
                        id="cancellationReason"
                        className="input-base"
                        value={surgeryData.cancellationReason}
                        onChange={(e) =>
                            handleChange("cancellationReason", e.target.value)
                        }
                    />
                </div>
                <div className="flex flex-col lg:flex-row gap-6 lg:gap-64">
                    <div className="flex flex-col gap-3">
                        <label className="block font-semibold leading-6 text-gray-900 dark:text-gray-200">
                            ¿Es un paciente privado?
                        </label>
                        <div className="flex flex-row gap-10">
                            <div className="flex flex-row gap-3 items-center">
                                <input
                                    type="radio"
                                    id="si"
                                    name="isPrivatePatient"
                                    value="si"
                                    checked={
                                        surgeryData.isPrivatePatient === true
                                    }
                                    onChange={() =>
                                        setSurgeryData((prev) => ({
                                            ...prev,
                                            isPrivatePatient: true,
                                        }))
                                    }
                                />
                                <label htmlFor="si">Si</label>
                            </div>

                            <div className="flex flex-row gap-3 items-center">
                                <input
                                    type="radio"
                                    id="no"
                                    name="isPrivatePatient"
                                    value="no"
                                    checked={
                                        surgeryData.isPrivatePatient === false
                                    }
                                    onChange={() =>
                                        setSurgeryData((prev) => ({
                                            ...prev,
                                            isPrivatePatient: false,
                                        }))
                                    }
                                />
                                <label htmlFor="no">No</label>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col gap-3">
                        <label className="block font-semibold leading-6 text-gray-900 dark:text-gray-200">
                            Quirofano
                        </label>
                        <div className="flex flex-row gap-10">
                            <div className="flex flex-row gap-3 items-center">
                                <input
                                    type="radio"
                                    id="quirofano_1"
                                    name="operatingRoom"
                                    value={1}
                                    checked={surgeryData.operatingRoom === 1}
                                    onChange={() =>
                                        setSurgeryData((prev) => ({
                                            ...prev,
                                            operatingRoom: 1,
                                        }))
                                    }
                                />
                                <label htmlFor="quirofano_1">1</label>
                            </div>

                            <div className="flex flex-row gap-3 items-center">
                                <input
                                    type="radio"
                                    id="quirofano_2"
                                    name="operatingRoom"
                                    value={2}
                                    checked={surgeryData.operatingRoom === 2}
                                    onChange={() =>
                                        setSurgeryData((prev) => ({
                                            ...prev,
                                            operatingRoom: 2,
                                        }))
                                    }
                                />
                                <label htmlFor="quirofano_2">2</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-6">
                    <div className="flex flex-col">
                        <label
                            htmlFor="surgeryDate"
                            className="block font-semibold leading-6 text-gray-900 dark:text-gray-200"
                        >
                            Fecha de la cirugía
                        </label>
                        <input
                            type="date"
                            name="surgeryDate"
                            id="surgeryDate"
                            value={surgeryData.surgeryDate}
                            onChange={(e) =>
                                handleChange("surgeryDate", e.target.value)
                            }
                            className={`input-base min-w-[195px] ${
                                formErrors.surgeryDate && "input-error"
                            }`}
                        />
                        {formErrors.surgeryDate && (
                            <p className="mt-2 text-sm text-red-600">
                                {formErrors.surgeryDate}
                            </p>
                        )}
                    </div>
                    <div className="flex flex-col">
                        <label
                            htmlFor="startTime"
                            className="block font-semibold leading-6 text-gray-900 dark:text-gray-200"
                        >
                            Hora de inicio de la cirugía
                        </label>
                        <input
                            type="time"
                            name="startTime"
                            id="startTime"
                            className={`input-base min-w-[195px] ${
                                formErrors.startTime && "input-error"
                            }`}
                            value={surgeryData.startTime}
                            onChange={(e) =>
                                handleChange("startTime", e.target.value)
                            }
                        />
                        {formErrors.startTime && (
                            <p className="mt-2 text-sm text-red-600">
                                {formErrors.startTime}
                            </p>
                        )}
                    </div>
                    <div className="flex flex-col">
                        <label
                            htmlFor="endTime"
                            className="block font-semibold leading-6 text-gray-900 dark:text-gray-200"
                        >
                            Hora de finalización
                        </label>
                        <input
                            type="time"
                            name="endTime"
                            id="endTime"
                            className={`input-base min-w-[195px] ${
                                formErrors.endTime && "input-error"
                            }`}
                            value={surgeryData.endTime}
                            onChange={(e) =>
                                handleChange("endTime", e.target.value)
                            }
                        />
                        {formErrors.endTime && (
                            <p className="mt-2 text-sm text-red-600">
                                {formErrors.endTime}
                            </p>
                        )}
                    </div>
                </div>
                <div className="flex flex-col">
                    <label
                        htmlFor="preoperativeDiagnosis"
                        className="block font-semibold leading-6 text-gray-900 dark:text-gray-200"
                    >
                        Diagnostico pre operatorio
                    </label>
                    <textarea
                        name="preoperativeDiagnosis"
                        rows={4}
                        className={`input-base ${
                            formErrors.preoperativeDiagnosis && "input-error"
                        }`}
                        value={surgeryData.preoperativeDiagnosis}
                        onChange={(e) =>
                            handleChange(
                                "preoperativeDiagnosis",
                                e.target.value
                            )
                        }
                    ></textarea>
                    {formErrors.preoperativeDiagnosis && (
                        <p className="mt-2 text-sm text-red-600">
                            {formErrors.preoperativeDiagnosis}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export const Enfermeria = ({ surgeryData, setSurgeryData, nurse }) => {
    const handleChange = (field, value) => {
        setSurgeryData((prev) => ({
            ...prev,
            [field]: value?.id,
        }));
    };
    return (
        <div className="bg-white dark:bg-gray-900 text-black dark:text-white min-h-[570px] py-8 px-6 lg:px-8 rounded-md shadow-md ">
            <div className="lg:w-9/12 flex-col space-y-6">
                <div className="flex flex-col">
                    <SimpleCombobox
                        inputClassName="relative mt-1"
                        placeholder={"Seleccionar enfermera"}
                        value={
                            nurse.find((m) => m.id === surgeryData.nurse) ||
                            null
                        }
                        handleChange={handleChange}
                        name="nurse"
                        label="Enfermera responsable"
                        className="shadow-sm pl-2 mt-1 w-full bg-white border border-gray-300 focus:ring-primary focus:border-primary block sm:text-sm rounded-md"
                        options={nurse}
                    />
                </div>
                <div className="flex flex-col">
                    <label
                        htmlFor="preoperativeDiagnosisNursing"
                        className="block font-semibold leading-6 text-gray-900 dark:text-gray-200"
                    >
                        Diagnostico pre operatorio
                    </label>
                    <textarea
                        name="preoperativeDiagnosisNursing"
                        rows={4}
                        className="input-base"
                        value={surgeryData.preoperativeDiagnosisNursing}
                        onChange={(e) =>
                            setSurgeryData((prev) => ({
                                ...prev,
                                preoperativeDiagnosisNursing: e.target.value,
                            }))
                        }
                    ></textarea>
                </div>
            </div>
        </div>
    );
};

export const TecnicaQuirurgica = ({ surgeryData, handleChange }) => {
    return (
        <div className="bg-white dark:bg-gray-900 text-black dark:text-white min-h-[570px] py-8 px-6 lg:px-8 rounded-md shadow-md ">
            <div className="lg:w-9/12 flex-col space-y-6">
                <div className="flex flex-col">
                    <label
                        htmlFor="surgicalTechnique"
                        className="block font-semibold leading-6 text-gray-900 dark:text-gray-200"
                    >
                        Técnica Quirúrgica
                    </label>
                    <textarea
                        name="surgicalTechnique"
                        rows={8}
                        className="input-base"
                        value={surgeryData.surgicalTechnique}
                        onChange={(e) =>
                            handleChange("surgicalTechnique", e.target.value)
                        }
                    ></textarea>
                </div>
            </div>
        </div>
    );
};

export const FichaAnestesica = ({ surgeryData, handleChange }) => {
    return (
        <div className="bg-white dark:bg-gray-900 text-black dark:text-white min-h-[570px] py-8 px-6 lg:px-8 rounded-md shadow-md ">
            <div className="lg:w-9/12 flex-col space-y-6">
                <div className="flex flex-col w-full lg:w-6/12">
                    <label
                        htmlFor="anesthesiaType"
                        className="block font-semibold leading-6 text-gray-900 dark:text-gray-200"
                    >
                        Tipo de anestecia
                    </label>
                    <select
                        name="anesthesiaType"
                        id="anesthesiaType"
                        className="input-base"
                        value={surgeryData.anesthesiaType}
                        onChange={(e) =>
                            handleChange("anesthesiaType", e.target.value)
                        }
                    >
                        <option value="" disabled hidden>
                            Sleccione una opción
                        </option>
                        <option value="1" selected>
                            Local
                        </option>
                        <option value="2" selected>
                            General
                        </option>
                        <option value="3" selected>
                            Sedación
                        </option>
                        <option value="4" selected>
                            Tópica
                        </option>
                    </select>
                </div>
                <div className="flex flex-col">
                    <label
                        htmlFor="patientResponses"
                        className="block font-semibold leading-6 text-gray-900 dark:text-gray-200"
                    >
                        Respuesta del paciente
                    </label>
                    <textarea
                        name="patientResponses"
                        rows={4}
                        className="input-base"
                        value={surgeryData.patientResponses}
                        onChange={(e) =>
                            handleChange("patientResponses", e.target.value)
                        }
                    ></textarea>
                </div>
                <div className="flex flex-col">
                    <label
                        htmlFor="surgicalComplications"
                        className="block font-semibold leading-6 text-gray-900 dark:text-gray-200"
                    >
                        Complicaciones de la intervención
                    </label>
                    <textarea
                        name="surgicalComplications"
                        rows={4}
                        className="input-base"
                        value={surgeryData.surgicalComplications}
                        onChange={(e) =>
                            handleChange(
                                "surgicalComplications",
                                e.target.value
                            )
                        }
                    ></textarea>
                </div>
            </div>
        </div>
    );
};

/*Por hacer */
export const Insumo = ({ surgeryData, handleChange }) => {
    const [supplies, setSupplies] = useState([]);
    const [usedSupplies, setUsedSupplies] = useState(
        surgeryData.usedSupplies.length > 0
            ? surgeryData.usedSupplies
            : []
    );
    useEffect(() => {
        api.supplies.getMulti().then((response) => {
            const supplyOptions = response.data.map((supply) => ({
                id: supply.id,
                name: supply.category,
            }));
            setSupplies(supplyOptions);
        });
    }, []);

    useEffect(() => {
        if (surgeryData.usedSupplies && surgeryData.usedSupplies.length > 0) {
            setUsedSupplies(surgeryData.usedSupplies);
        }
    }, [surgeryData]);

    const handleSupplyChange = (name, selectedOption, index) => {
        const newUsedSupplies = [...usedSupplies];
        if (selectedOption?.id) {
            newUsedSupplies[index].supply = selectedOption.id;
        }
        setUsedSupplies(newUsedSupplies);
        handleChange("usedSupplies", newUsedSupplies);
    };

    const handleQuantityChange = (index, quantity) => {
        const newUsedSupplies = [...usedSupplies];
        newUsedSupplies[index].quantity = Number(quantity);
        setUsedSupplies(newUsedSupplies);
        handleChange("usedSupplies", newUsedSupplies);
    };

    return (
        <div className="bg-white dark:bg-gray-900 text-black dark:text-white min-h-[570px] py-8 px-6 lg:px-8 rounded-md shadow-md ">
            <div className="lg:w-9/12 flex-col space-y-6">
                <h2 className="text-2xl font-semibold mb-6">
                    Insumos utilizados
                </h2>
                <div className="flex flex-col gap-8 lg:gap-6">
                    {usedSupplies?.map((item, index) => (
                        <div
                            key={`${item.supply}-${index}`}
                            className="flex flex-col lg:flex-row gap-2 lg:gap-10 items-end"
                        >
                            <div className="w-full lg:w-4/12">
                                <SimpleCombobox
                                    inputClassName="relative mt-1"
                                    placeholder={"Selecciona un insumo"}
                                    handleChange={handleSupplyChange}
                                    Idx={index}
                                    name="supply"
                                    label={`Insumo ${index + 1}`}
                                    className="shadow-sm pl-2 mt-1 w-full bg-white border border-gray-300 focus:ring-primary focus:border-primary block sm:text-sm rounded-md"
                                    options={supplies}
                                    value={
                                        supplies.find(
                                            (s) => s.id === item.supply
                                        ) ?? null
                                    }
                                />
                            </div>
                            <div className="w-full lg:w-2/12">
                                <label className="block leading-6 text-gray-900 dark:text-gray-200">
                                    Cantidad
                                </label>
                                <input
                                    type="number"
                                    value={item.quantity}
                                    onChange={(e) =>
                                        handleQuantityChange(
                                            index,
                                            e.target.value
                                        )
                                    }
                                    className="input-base"
                                />
                            </div>
                        </div>
                    ))}
                </div>
                <button
                    type="button"
                    className="text-primary flex justify-center items-center rounded-md cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 py-2 px-4"
                    onClick={() => {
                        setUsedSupplies([
                            ...usedSupplies,
                            { supply: null, quantity: 0 },
                        ]);
                    }}
                >
                    Agregar insumo
                </button>
            </div>
        </div>
    );
};
